export default __webpack_public_path__ + "static/char-s-08-cht-b03bbb80e661c8fd096945855c56ca8f.webp";